export const BUY_ONLINE_ACQUISITION_CREATIVE_ID = 'edm-buy-online-acquisition-module';

export const BUY_ONLINE_ACQUISITION_DATA = {
  header: 'Buy Online. Buy Stress-free.',
  items: [
    'Pricing, trade-in, and financing all online',
    'Get the car delivered',
    "7-day return period if you don't love it",
  ],
};
